import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/logo.png";
import { Button } from "@mui/material";
import { Menu } from "@mui/icons-material";
import { navs } from "../../datas/Landing";
import { useRecoilState } from "recoil";
import { Responsive } from "../../context/landing/Responsive";
import { user } from "../../atom";
import axios from "../../axios";

function Navigation({ link, title }) {
  const { width, scroll, device } = useContext(Responsive);
  const [loading, setLoading] = useState(false);
  const [_, setCurrentuser] = useRecoilState(user);
  const navigate = useNavigate();
  useEffect(() => {
    document.title = title;
  }, [title]);

  const [dropdown, setDropdown] = useState(false);
  const drop = () => {
    setDropdown(true);
  };

  const notDrop = () => {
    setDropdown(false);
  };

  useEffect(() => {
    window.scrollBy({ top: -window.scrollY });
  }, []);
  const start = async () => {
    setLoading(true);
    let token = localStorage.getItem("token");
    try {
      const res = await axios.post("/api/auth/token", null, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTimeout(() => {
        setLoading(false);
        if (!res.data) return navigate("/registry/login");
        setCurrentuser(res.data);
        navigate("/");
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      navigate("/registry/login");
    }
  };
  return (
    <>
      <div
        className={`${scroll || link !== "primarycare"
            ? "bg-white shadow-md drop-shadow-md"
            : "bg-transparent"
          } z-30 w-full ${!width ? "px-5" : "px-2"
          } duration-500  flex justify-between h-[5rem] items-center fixed top-0`}
      >
        {width && (
          <div className=" relative">
            {device === "desktop" ? (
              <div
                className="relative"
                onMouseEnter={drop}
                onMouseLeave={notDrop}
              >
                <Menu
                  className="cursor-pointer"
                  style={{ width: "2.5rem", height: "2.5rem" }}
                />
                {dropdown && (
                  <div className="flex shadow-lg drop-shadow-lg rounded-[10px] flex-col w-[12rem] absolute bg-white ">
                    {navs.map((nav, index) => (
                      <Link
                        to={`/landing/${nav.path}`}
                        key={index}
                        className={`font-semibold px-3 py-1 hover:text-[white] ${index === 0 && "rounded-t-[10px]"
                          } ${index === navs.length - 1 && "rounded-b-[10px]"
                          } hover:bg-[#1a489d] text-xl ${link === nav.path && "text-[#1a489d]"
                          }`}
                      >
                        {nav.link}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div>
                <Menu
                  onClick={drop}
                  style={{ width: "2.5rem", height: "2.5rem" }}
                />
                {dropdown && (
                  <div className="flex shadow-lg drop-shadow-lg rounded-[10px] py-3 flex-col  w-[10rem] gap-3 absolute bg-white">
                    {navs.map((nav, index) => (
                      <Link
                        to={`/landing/${nav.path}`}
                        key={index}
                        className={`font-semibold px-3 hover:text-[white] hover:bg-[#1a489d] text-xl ${link === nav.path && "text-[#1a489d]"
                          }`}
                      >
                        {nav.link}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        <Link to="/primarycare">
          <img alt="logo" src={Logo} className="h-[2.5rem] min-w-[6rem]" />
        </Link>
        {!width && (
          <div className="flex items-center gap-[1.5rem]">
            {navs.map((nav, index) => (
              <Link
                to={`/landing/${nav.path}`}
                key={index}
                className={`font-semibold text-xl ${link === nav.path && "text-[#1c1a9d]"
                  }`}
              >
                {nav.link}
              </Link>
            ))}
            <Button
              onClick={start}
              variant="contained"
              style={{ background: "#243A86" }}
            >
              Get Started
            </Button>
          </div>
        )}
        {width && (
          <Button
            style={{ backgroundColor: "#243A86", fontSize: "bold" }}
            variant="contained"
            onClick={start}
          >
            Get Started
          </Button>
        )}
      </div>
    </>
  );
}

export default Navigation;
